module.exports = __webpack_public_path__ + "img/the-blockchain-game.678e874d.png";